/* 🤖 this file was generated by script */
export const wsolidiconPencil02 = {
  name: 'pencil_02',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M18.7 1.3a1 1 0 1 0-1.4 1.4l4 4a1 1 0 1 0 1.4-1.4zM14.54 4.28a1.5 1.5 0 0 1 1.44.3l.28.26 2.9 2.9.26.28q.17.17.3.52a1.5 1.5 0 0 1-.3 1.44l-.26.28L8.77 20.64q-.27.3-.54.5a3 3 0 0 1-.54.3q-.32.14-.7.23l-4.73 1.3a1 1 0 0 1-1.22-1.23L2.33 17q.1-.38.22-.7a3 3 0 0 1 .8-1.08l10.4-10.39.27-.26q.17-.16.52-.3"/></svg>`,
  iconStyle: 'solid',
};
